import { render, staticRenderFns } from "./video-chat.vue?vue&type=template&id=45dd2a4e&scoped=true&"
import script from "./video-chat.vue?vue&type=script&lang=js&"
export * from "./video-chat.vue?vue&type=script&lang=js&"
import style0 from "./video-chat.vue?vue&type=style&index=0&id=45dd2a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd2a4e",
  null
  
)

component.options.__file = "video-chat.vue"
export default component.exports